import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    padding: 4rem 15% 6rem;
    margin: 0 auto;
    width: 70%;
    overflow: hidden;
    .bg-image {
        z-index: -1;
        position: absolute;
        inset: 0 0 0 0;
        ::after {
            content: ' ';
            position: absolute;
            inset: 0 0 0 0;
            background-color: #00000088;
            backdrop-filter: blur(3px);
        }
        img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
    }
    .title {
        z-index: 5;
        font-size: 1.6rem;
        font-weight: 800;
        margin-bottom: 1.3rem;
        color: #fff;
        letter-spacing: 2px;
    }
    .items {
        width: 100%;
        display: grid;
        --grid-col: 3;
        --grid-gap: 1rem;
        grid-template-columns: repeat(var(--grid-col), calc(calc(100% / var(--grid-col)) - calc(calc(var(--grid-gap) * calc(var(--grid-col) - 1)) / var(--grid-col))));
        grid-gap: var(--grid-gap);
        grid-auto-rows: 1fr;
        .card {
            border-radius: 1rem;
            background-color: #fff;
            padding: 2rem 1rem;
            display: flex;
            flex-direction: column;
            position: relative;
            transition: all 0.1s linear;
            box-shadow: 0 5px 25px -10px #000;
            .card-icon {
                margin: 0 auto;
                width: 3rem;
                margin-bottom: 1rem;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                }
            }
            .card-title {
                font-size: 1.2rem;
                font-weight: 600;
                margin-bottom: 0.7rem;
            }
            .card-text {
                font-size: 1rem;
            }
        }
    }
    @media (max-width: 850px){
        .items {
            --grid-col: 1;
            --grid-gap: 1rem;
        }
    }
`;

export default function CenterItems({data, scroll}) {
    const mainref = useRef()
    const [anim, setAnim] = useState(0);
    useEffect(()=> {
        if(mainref.current && data.animation){
            if(scroll + window.innerHeight > mainref.current.offsetTop){
                let obs = (scroll + window.innerHeight/2) - mainref.current.offsetTop
                if(obs > mainref.current.offsetHeight/2){
                    obs = mainref.current.offsetHeight/2
                }
                obs = obs / (mainref.current.offsetHeight/2)
                if(window.innerWidth < 1000){
                    setAnim(25 - (obs * 25));
                } else {
                    setAnim(50 - (obs * 50));
                }
            }
        }
    }, [scroll, data])


    const makeCards = () => {
        return data.data.map((value, index) => {
            let val = {
                right: -anim + "%",
            }
            
            if(window.innerWidth < 1000){
                if(index % 2 === 1){
                    val = {
                        left: -anim + "%",
                    }
                }
            } else {
                if(Math.floor((index / 3)) % 2 === 1){
                    val = {
                        left: -anim + "%",
                    }
                }
            }
            return (
                <div className="card" style={val} key={index}>
                    <div className="card-icon">
                        <img src={value.icon} alt={value.title}/>
                    </div>
                    <div className="card-title">
                        {value.title}
                    </div>
                    <div className="card-text">
                        {value.text}
                    </div>
                </div>
            )
        })
    }
    let image = '';
    if(data.bgimage){
        image = (
            <div className="bg-image">
                <img src={data.bgimage} alt={data.title}/>
            </div>
        )
    }
    return (
      <Style id={data.title} ref={mainref}>
        {image}
        <div className="title">
            {data.title}
        </div>
        <div className="items">
            {makeCards()}
        </div>
      </Style>
  );
}
